<template>
  <div class="container">
   
    <enable @enableMenuList="handleChildEvent"></enable>
    <div class="category">
      <p class="title">精选品类</p>
      <div class="category-floor-body">
        <div class="body-item"  v-for="item,i in enableMenuList" :key="item.cate_id">
          <div class="itemTile">
            <p class="title-p" @click="TitleCommodityId1(item)">{{ item.cate_name }}</p>
            <div>
              <p  v-for="sub,index in item.children" :key="sub.cate_id" @mouseenter="getLists(item,index,i)">
                 
                 <span v-if="sub.is_recommend == 1" @click="TitleCommodityId2(item,sub,sub.children)">{{ sub.cate_name }} <i class="el-icon-caret-right"></i></span>
              </p>
            </div>
          </div>
          <div class="body-magnet">
            <div class="body-magnet-item" v-for="itemA,s_sIndex in item.enableCategory" :key="itemA.id" @click="handleExableInfo(itemA)" v-if="s_sIndex < 4">
              <div class="lazyload">
                <div class="img" v-if="itemA.firstFile.FileUrl != ''">
                  <img :src="itemA.firstFile.FileUrl" style="width: 122px;height: 122px; object-fit: cover;" alt="">
                </div>
                <!-- <p>{{ item.name }}</p> -->
                <p class="titleH4">{{ itemA.name}}</p>
              </div>
              <p class="priceD">
                <span>￥</span>
                <span class="price">{{ itemA.price }}</span>
                <span class="unit">/{{ itemA.unit }}</span>
              </p>
            </div>
            
          </div>
        </div>
       
      </div>
    </div>
    
  </div>
</template>

<script>
import enable from '@/pages/funeng/enable'
export default{
    data(){
        return {
            enableMenuList: [],
            sort_type: 'uni',
            product_types: [ 'product','jifen','service'],
            sort_value: 0,
        }
    },
    components: {
      enable
    },
    methods: {
      TitleCommodityId1(item){
          console.log(item);
         
          sessionStorage.setItem('enableItem',JSON.stringify(item))
          sessionStorage.setItem('enableSub','')
          sessionStorage.setItem('s_subs','')
          this.$router.push({
              path: '/enable'
          })
          
      },
      TitleCommodityId2(item,subItem){
          console.log(item);
          console.log(subItem);
          sessionStorage.setItem('enableItem',JSON.stringify(item))
          sessionStorage.setItem('enableSub',JSON.stringify(subItem))
          sessionStorage.setItem('s_subs','')
          this.$router.push({
              path: '/enable'
          })
          
      },
      handleChildEvent(value) {
        this.enableMenuList = value;
         console.log("=====================");
        console.log(this.enableMenuList);
        this.enableMenuList.forEach((item,index) => {
        
          this.$set(item,'enableCategory',[])
          console.log(item.children);
          let list = item.children[0]
          this.gesListEnable(list,item,index)
        });
       
        
      },
   
     
      handleExableInfo(item){
            console.log(item);
            
           if(item != ''){
            const { href } = this.$router.resolve({
                path: "/enableInfo",
                query: {
                    id: item.id,
                }
            });
            window.open(href, '_blank');
           }
        },
 
      gesListEnable(list,item,index){
          if(list.is_recommend == '1'){
            this.getLists(item, 0, index)
        
          }

        
      },
      getLists(item,subIndex,index){
        let items = {
            pageNum: 1,
            pageSize: 4,
            cate: item.cate_id,
            sub_cate: item.children[subIndex].cate_id,
            s_sub_cate: '',//item.children[subIndex].children[0].cate_id,
            keywords: '',
            product_types: this.product_types,
            sort_type: this.sort_type,
            sort_value: this.sort_value,
        }
        console.log(items);
        this.$store.dispatch('enable/listproduct',items)
          .then(res => {
              if(res.ok){
                const listprodu = res.data.items
                this.enableMenuList[index].enableCategory = []
                listprodu.forEach(item => {
                  this.enableMenuList[index].enableCategory.push(item)
                   
                });

                 

              }
          })
      },
       getLists(item,subIndex,index){
        let items = {
            pageNum: 1,
            pageSize: 4,
            cate: item.cate_id,
            sub_cate: item.children[subIndex].cate_id,
            s_sub_cate: '',
            keywords: '',
            product_types: this.product_types,
            sort_type: this.sort_type,
            sort_value: this.sort_value,
        }
        console.log(items);
        this.$store.dispatch('enable/listproduct',items)
          .then(res => {
              if(res.ok){
                const listprodu = res.data.items
                this.enableMenuList[index].enableCategory = []
                listprodu.forEach(item => {
                  this.enableMenuList[index].enableCategory.push(item)
                   
                });

                 

              }
          })
      }
       
    },
    mounted(){}
 
  
}
</script>

<style lang='scss' scoped>
.container {
  width: 1200px;

  margin: 0 auto;
  padding-bottom: 10px;
  
 
  .category{
    width: 1200px;
    padding-bottom: 20px;
    .title{
      font-size: 22px;
      color: #333333;
    }
    .category-floor-body{
      display: flex;
      justify-content: flex-start;
      flex-flow: row wrap;
      min-height: 556px;min-width: 100%;
      .body-item{
        width: 595px;height: 526px;
        background: #fff;
        margin-top: 15px;
        display: flex;
        justify-content: flex-start;
        .itemTile{
          width: 160px;
          padding: 20px 20px;
          background: #e6e6e6;
          overflow: hidden;
          text-overflow: hidden;
          overflow-y: auto;
          .title-p{
                margin-left: 8px;
                font-size: 16px;
                font-weight: 700;
                border-radius: 15px;
                color: #2c3038;
                cursor: pointer;
                
          }
          div{
            margin-top: 8px;
            p{
              height: 20px;
              width: 100%;
              line-height: 20px;
              padding-left: 10px;
              border-radius: 10px;
              font-size: 16px;
              color: #55575a;
              margin-bottom: 20px;
              overflow: hidden;
              text-overflow: hidden;
              cursor: pointer;
              i{
                color: #f2f2f2;
                border-radius: 50%;
                font-size: 10px;
                padding: 1px 1px;
                border: 1px solid;
                background: #afafaf;
                display: none;
                
              }
            }
            p:hover{
              font-weight: 700;
              color: #2c3038;
              
            }
            p:hover i{
              display: block;
              display: inline;
            }
          }

        }
        .body-magnet{
          width: 492px;
          display: flex;
          justify-content: flex-start;
          flex-flow: row wrap;
          .body-magnet-item{

            padding: 0 10px;
            width: 188px;
            height: 262px;
            background: #fff;
            border-right: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            .lazyload {
              display: block;
              width: 100%;
              text-align: center;
              margin-top: 20px;
              cursor: pointer;
              .img{
                width: 122px;height: 122px;
                margin: 0 auto;
                
              }
              P{
                font-size: 14px;
                margin-top: 5px;
                color: #666666;
              }
              .titleH4{
                margin-top: 20px;
                height: 55px;
                line-height: 18px;
                color: #333;
                font-size: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                text-align: left;
                margin-bottom: 16px;
                cursor: pointer;
              }
            }
            .lazyload:hover .titleH4{
              color: #10aeff;
            }
            .lazyload:hover p{
              color: #10aeff;
            }
            .priceD{
              display: flex;
              align-items: baseline;
              color: #f74747;
              font-size: 14px;
              font-weight: 700;
              margin-top: -5px;
              .price{
                font-size: 18px;
              }
              .unit{
                color: #666666;
              }
            }
            
          }
        }
      }
      .body-item:nth-child(2n+1){
        margin-right: 10px;
      }
    }
  }
  
}
ul{
  margin: 0 0;
  font-size: 16px;
  color: #333333;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: row wrap;
  li{
    margin: 3px 5px;
    cursor: pointer;
  }
  li:hover{
    color: #10aeff;
  }
}
::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    ::-webkit-scrollbar-track {
        background-color:transparent;
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius:2em;
    }
    ::-webkit-scrollbar-thumb {
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius:2em;
    }
</style>